import { computed, defineComponent, onMounted } from "vue";
import { myPageStore } from "./store/MyPageStore";
import { commonStore } from "./store/CommonStore";
import { auth } from "~/core";
import { useRoute, useRouter } from "vue-router";
import { routeManager } from "src/router/RouteManager";
export default defineComponent({
    name: "App",
    setup() {
        const route = useRoute();
        const isLoginPage = computed(() => route.name === "login");
        onMounted(async () => {
            if ((!isLoginPage.value && myPageStore.loadError) || commonStore.initError) {
                const router = useRouter();
                try {
                    await auth.logout();
                }
                catch (ex) {
                    auth.logoutLocal();
                }
                finally {
                    routeManager.reset();
                }
                router.push({ name: "404" });
            }
        });
    }
});
